import React from "react";
import { Modal } from "antd";

const SupportModal = ({ onCancel, title, issueTitle, issueDescription }) => {
  return (
    <div>
      <Modal
        open={true}
        footer={null}
        className="space-y-20" // Center the modal
        onCancel={onCancel}
        width="479px"
      >
        <h3 className="text-primaryPurple">{title}</h3>
        <p>
          <span className="font-bold text-primaryPurple">Issue Title:</span>{" "}
          {issueTitle}
        </p>
        <p>
          <span className="text-primaryPurple font-bold">Description:</span>{" "}
          {issueDescription}
        </p>
        <p></p>
      </Modal>
    </div>
  );
};
export default SupportModal;
